var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVoiceRecorder1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.518,
    height: 70.052,
    viewBox: "0 0 79.518 70.052",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "voice-recorder",
    transform: "translate(0 -30.474)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_975",
    "data-name": "Group 975",
    transform: "translate(18.432 67.835)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_974",
    "data-name": "Group 974",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3075",
    "data-name": "Path 3075",
    d: "M161.334,273.37a2.335,2.335,0,1,0-4.67,0,16.66,16.66,0,0,1-33.314,0,2.335,2.335,0,1,0-4.67,0c0,10.789,8.513,19.6,18.992,20.78v4.906h-7.317a2.335,2.335,0,1,0,0,4.67h19.3a2.335,2.335,0,1,0,0-4.67h-7.317V294.15C152.821,292.971,161.334,284.159,161.334,273.37Z",
    transform: "translate(-118.68 -271.035)",
    fill: "#7dbaab"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_977",
    "data-name": "Group 977",
    transform: "translate(27.772 30.474)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_976",
    "data-name": "Group 976",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3076",
    "data-name": "Path 3076",
    d: "M190.807,30.474A11.959,11.959,0,0,0,178.82,42.149V70.17a11.991,11.991,0,0,0,23.973,0V42.149A11.959,11.959,0,0,0,190.807,30.474Z",
    transform: "translate(-178.82 -30.474)",
    fill: "#7dbaab"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_979",
    "data-name": "Group 979",
    transform: "translate(68.006 33.329)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_978",
    "data-name": "Group 978",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3077",
    "data-name": "Path 3077",
    d: "M441.867,49.542a2.335,2.335,0,1,0-3.3,3.3,21.011,21.011,0,0,1,0,29.72,2.335,2.335,0,0,0,3.3,3.3,25.679,25.679,0,0,0,0-36.324Z",
    transform: "translate(-437.881 -48.858)",
    fill: "#7dbaab"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_981",
    "data-name": "Group 981",
    transform: "translate(61.398 39.937)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_980",
    "data-name": "Group 980"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3078",
    "data-name": "Path 3078",
    d: "M399.318,92.091a2.335,2.335,0,1,0-3.3,3.3,11.652,11.652,0,0,1,0,16.5,2.335,2.335,0,1,0,3.3,3.3,16.32,16.32,0,0,0,0-23.107Z",
    transform: "translate(-395.332 -91.407)",
    fill: "#7dbaab"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_983",
    "data-name": "Group 983",
    transform: "translate(54.796 46.539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_982",
    "data-name": "Group 982",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3079",
    "data-name": "Path 3079",
    d: "M356.81,134.6a2.335,2.335,0,0,0-3.3,3.3,2.326,2.326,0,0,1,0,3.3,2.335,2.335,0,0,0,3.3,3.3,6.995,6.995,0,0,0,0-9.9Z",
    transform: "translate(-352.824 -133.914)",
    fill: "#7dbaab"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_985",
    "data-name": "Group 985",
    transform: "translate(0 33.329)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_984",
    "data-name": "Group 984"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3080",
    "data-name": "Path 3080",
    d: "M4.67,67.7a20.869,20.869,0,0,1,6.157-14.859,2.335,2.335,0,1,0-3.3-3.3,25.679,25.679,0,0,0,0,36.324,2.335,2.335,0,1,0,3.3-3.3A20.874,20.874,0,0,1,4.67,67.7Z",
    transform: "translate(0 -48.857)",
    fill: "#7dbaab"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_987",
    "data-name": "Group 987",
    transform: "translate(9.34 39.937)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_986",
    "data-name": "Group 986",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3081",
    "data-name": "Path 3081",
    d: "M64.809,103.644a11.587,11.587,0,0,1,3.425-8.25,2.335,2.335,0,0,0-3.3-3.3,16.32,16.32,0,0,0,0,23.107,2.335,2.335,0,1,0,3.3-3.3A11.6,11.6,0,0,1,64.809,103.644Z",
    transform: "translate(-60.139 -91.407)",
    fill: "#7dbaab"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_989",
    "data-name": "Group 989",
    transform: "translate(18.68 46.539)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_988",
    "data-name": "Group 988"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3082",
    "data-name": "Path 3082",
    d: "M124.949,139.548a2.32,2.32,0,0,1,.686-1.649,2.335,2.335,0,0,0-3.3-3.3,6.994,6.994,0,0,0,0,9.9,2.335,2.335,0,0,0,3.3-3.3A2.32,2.32,0,0,1,124.949,139.548Z",
    transform: "translate(-120.279 -133.913)",
    fill: "#7dbaab"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceRecorder1);
export default __webpack_public_path__ + "static/media/voice-recorder (1).3538e645a187d64e6a177f610251e364.svg";
export { ForwardRef as ReactComponent };